/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

export const PROPERTY_SEARCH_ROW_CONDITION_VALUE = {
  USAGE: 'USAGE',
  EQUALS: 'EQUALS',
  CONTAINS: 'CONTAINS',
  CONTAINS_ANY: 'CONTAINS_ANY',
  CONTAINS_ALL: 'CONTAINS_ALL',
  EQUALS_ANY_OF: 'EQUALS_ANY_OF',
  LESS_THAN_OR_EQUALS_TO: 'LESS_THAN_OR_EQUALS_TO',
  LESS_THAN: 'LESS_THAN',
  GREATER_THAN_OR_EQUALS_TO: 'GREATER_THAN_OR_EQUALS_TO',
  GREATER_THAN: 'GREATER_THAN',
  NEXT_N_DAYS: 'NEXT_N_DAYS',
  PREVIOUS_N_DAYS: 'PREVIOUS_N_DAYS'
}

export const metadataCriteriaEmptyRow = {
  value: '',
  metadataTemplateId: null,
  condition: PROPERTY_SEARCH_ROW_CONDITION_VALUE.USAGE,
  includeInherited: true
}
